module.exports = __webpack_public_path__ + "img/message-scheduler.1d961f04.webp";